import { Formik } from 'formik';
import React, { useContext } from 'react';
import styled from 'styled-components';

import MagnifyingGlassIcon from '@icons/MagnifyingGlassIcon';
import TextInput from '@atoms/TextInput';
import colors from '@general/colors';
import { ConversationSearchContext } from './providers/ConversationSearchProvider';
import { ConversationsContext } from '../../../context/ConversationsProvider';

const SubmitButtonStyled = styled.button`
    position: absolute;
    bottom: 0;
    right: 0;
    height: 54px;
    width: 54px;
    background-color: ${colors.azure};
`;

const ConversationSearch = () => {
    const { conversations } = useContext(ConversationsContext);
    const { conversationSearchQuery, setConversationSearchQuery } = useContext(ConversationSearchContext);

    const handleSubmit = e => {
        e.preventDeault();
    };

    const onChange = e => {
        setConversationSearchQuery(e.target.value.toLowerCase());
    };

    if (!conversations || conversations.length === 0) {
        return null;
    }

    return (
        <Formik onSubmit={handleSubmit} enableReinitialize initialValues={{ query: '' }}>
            {formik => (
                <div style={{ position: 'relative' }}>
                    <TextInput
                        autoComplete="off"
                        name="query"
                        type="search"
                        value={conversationSearchQuery}
                        onChange={onChange}
                        // onKeyDown={onKeyDown}
                        placeholder="Search names..."
                    />
                    <SubmitButtonStyled
                        type="submit"
                        title="Submit your search query."
                        className="ais-SearchBox-submit"
                    >
                        <MagnifyingGlassIcon size={20} />
                    </SubmitButtonStyled>
                </div>
            )}
        </Formik>
    );
};

// ConversationSearch.propTypes = {
//     prop: PropTypes.
// };

export default ConversationSearch;
